import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::upsert
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:302
* @route '/motels/{motel}/profit-loss/entries'
*/
export const upsert = (args: { motel: string | { id: string } } | [motel: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upsert.url(args, options),
    method: 'post',
})

upsert.definition = {
    methods: ["post"],
    url: '/motels/{motel}/profit-loss/entries',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::upsert
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:302
* @route '/motels/{motel}/profit-loss/entries'
*/
upsert.url = (args: { motel: string | { id: string } } | [motel: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { motel: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: typeof args.motel === 'object'
        ? args.motel.id
        : args.motel,
    }

    return upsert.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::upsert
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:302
* @route '/motels/{motel}/profit-loss/entries'
*/
upsert.post = (args: { motel: string | { id: string } } | [motel: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upsert.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::upsert
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:302
* @route '/motels/{motel}/profit-loss/entries'
*/
const upsertForm = (args: { motel: string | { id: string } } | [motel: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: upsert.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::upsert
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:302
* @route '/motels/{motel}/profit-loss/entries'
*/
upsertForm.post = (args: { motel: string | { id: string } } | [motel: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: upsert.url(args, options),
    method: 'post',
})

upsert.form = upsertForm

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::copy
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:322
* @route '/motels/{motel}/profit-loss/entries/copy-to-all-months'
*/
export const copy = (args: { motel: string | { id: string } } | [motel: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: copy.url(args, options),
    method: 'post',
})

copy.definition = {
    methods: ["post"],
    url: '/motels/{motel}/profit-loss/entries/copy-to-all-months',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::copy
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:322
* @route '/motels/{motel}/profit-loss/entries/copy-to-all-months'
*/
copy.url = (args: { motel: string | { id: string } } | [motel: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { motel: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: typeof args.motel === 'object'
        ? args.motel.id
        : args.motel,
    }

    return copy.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::copy
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:322
* @route '/motels/{motel}/profit-loss/entries/copy-to-all-months'
*/
copy.post = (args: { motel: string | { id: string } } | [motel: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: copy.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::copy
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:322
* @route '/motels/{motel}/profit-loss/entries/copy-to-all-months'
*/
const copyForm = (args: { motel: string | { id: string } } | [motel: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: copy.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::copy
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:322
* @route '/motels/{motel}/profit-loss/entries/copy-to-all-months'
*/
copyForm.post = (args: { motel: string | { id: string } } | [motel: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: copy.url(args, options),
    method: 'post',
})

copy.form = copyForm

const entries = {
    upsert: Object.assign(upsert, upsert),
    copy: Object.assign(copy, copy),
}

export default entries